import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';


  
  export const projectsSlice = createSlice({
    name: 'projects',
    initialState,
    reducers: {
      setProjects:(state, action) => {
        state.projectsData = action.payload
      }
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const { setProjects } = projectsSlice.actions
  
  export default projectsSlice.reducer